import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsDesignernewsComponent } from './simple-icons-designernews.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsDesignernewsComponent ],
    exports:      [ SimpleIconsDesignernewsComponent ],
    bootstrap:    []
})
export class SimpleIconsDesignernewsModule {}
